//
// InnerMargin.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "./Overlay";
import "../core/Alignment";
import "../core/styles/FillAttributes";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "../core/Pad";
import "../core/styles/LineAttributes";
import "../data/RoleMetadata";

var InnerMargin = createModule("gtl::InnerMargin", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        gutter: 1,
        pad: 1,
        opaque: 2,
        separatorAttributes: 1,
        overlays: [1],
        align: 4,
        backgroundAttributes: 1,
        separator: 2,
    },
    ,
    ,
    {
        createRoleMetadata: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default InnerMargin;
